import { ResponsiveLine } from "@nivo/line";
import { ResponsiveBar } from '@nivo/bar'
import { useTheme } from "@mui/material";
import { tokens } from "../contexts/theme";

const FormatLineChart = ({ data, is_dashboard, y_label, boundary }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const color_info = {
    text: {
      fill: colors.grey[100],
    },
    axis: {
      domain: {
        line: {
          stroke: colors.grey[100],
        },
      },
      legend: {
        text: {
          fill: colors.grey[100],
        },
      },
      ticks: {
        line: {
          stroke: colors.grey[100],
          strokeWidth: 1,
        },
        text: {
          fill: colors.grey[100],
        },
      },
    },
    legends: {
      text: {
        fill: colors.grey[100],
      },
    },
    tooltip:{
      container:{
        color: "#141414",
      }
    }
  };

  return is_dashboard ? (
    <ResponsiveBar 
      data={data}
      keys={['Tunnel-1', 'Tunnel-2']}
      indexBy="Sensor"
      margin={{ top: 10, right: 140, bottom: 50, left: 50 }}
      valueScale={{ type: 'linear' }}
      indexScale={{ type: 'band', round: true }}
      colors={{ scheme: 'nivo' }}
      axisTop={null}
      axisRight={null}
      // padding={0.4}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: 'Sensor',
        legendPosition: 'middle',
        legendOffset: 32,
        truncateTickAt: 0
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legendPosition: 'middle',
        legendOffset: -40,
        truncateTickAt: 0
      }}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{
        from: 'color',
        modifiers: [[
          'darker',
          1.6
        ]]
      }}
      legends={[
        {
          dataFrom: 'keys',
          anchor: 'bottom-right',
          direction: 'column',
          justify: false,
          translateX: 120,
          translateY: 0,
          itemsSpacing: 2,
          itemWidth: 112,
          itemHeight: 20,
          itemDirection: 'left-to-right',
          itemOpacity: 0.85,
          symbolSize: 20,
          effects: [
            {
              on: 'hover',
              style: {
                itemOpacity: 1
              }
            }
          ]
        }
      ]}
      theme={color_info}
      role="application"
      barAriaLabel={e=>e.id+": "+e.formattedValue+" of Sensor: "+e.indexValue}
    />
  ): (
    <ResponsiveLine
      data={data}
      margin={{bottom: 80, left: 50, right: 70, top: 20}}
      xScale={{
        type: "time",
        format: "%Y-%m-%dT%H:%M",
        precision: "second",
      }}
      xFormat="time:%Y.%m.%d %H:%M:%S"
      yScale={{type: "linear", min: "auto", max: "auto"}}
      yFormat=">-.2f"
      axisTop={null}
      axisBottom={{
        format: "%y.%m.%d %H:%M",
        legend: "time scale",
        legendOffset: 36,
        legendPosition: "middle",
      }}
      axisLeft={{
        legendPosition: "middle",
        legendOffset: -40,
      }}
      pointSize={3}
      pointBorderWidth={2}
      pointBorderColor={{ from: "serieColor"}}
      enablePointLabel={false}
      pointLabelYOffset={-12}
      enableTouchCrosshair={true}
      enablePoints={true}
      useMesh={true}
      legends={[
        {
          anchor: "bottom",
          direction: "row",
          justify: false,
          translateX: 30,
          translateY: 70,
          itemsSpacing: 0,
          itemDirection: "left-to-right",
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: "circle",
          symbolBorderColor: "rgba(0, 0, 0, .5)",
          effects: [
            {
              on: "hover",
              style: {
                itemBackground: "rgba(0, 0, 0, .03)",
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
      theme={color_info}
    />
  );
};

export default FormatLineChart;
